// Libraries
import {
  FormGroup
}  from '@angular/forms';

import * as _ from 'lodash';

/**
 * Provides a set of methods used for forms.
 */
export class FormUtils {
  /**
   * Convert form control errors into a form errors object.
   * @param form Current form
   * @param formErrors Current form errors
   * @param validationMessages Validation messages
   */
  static parseErrors(form: FormGroup, formErrors: any, validationMessages: any): any {
    for (const field in formErrors) {
      if (Object.prototype.hasOwnProperty.call(formErrors, field)) {
        // Clear previous error message (if any)
        formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = validationMessages[field];
          for (const key in control.errors) {
            if (Object.prototype.hasOwnProperty.call(control.errors, key)) {
              const value = control.errors[key];
              // If value is not object, copy error message
              if (!_.isObject(value)) {
                formErrors[field] += messages[key] + ' ';
              } else {
                for (const errorKey in value) {
                  if (Object.prototype.hasOwnProperty.call(value, errorKey)) {
                    const errorValue = value[errorKey];
                    if (Object.prototype.hasOwnProperty.call(messages[key], errorValue)) {
                      formErrors[field] += messages[key][errorValue] + ' ';
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return formErrors;
  }

  /**
   * Convert backend errors into a form errors object.
   * @param form Current form
   * @param formErrors Current form errors
   * @param backendErrors Backend errors
   */
  static parseBackendErrors(_form: FormGroup, formErrors: any, backendErrors: any): any {
    for (const field in formErrors) {
      if (Object.prototype.hasOwnProperty.call(backendErrors, field) && backendErrors[field]) {
        if (_.isArray(backendErrors[field])) {
          // Copy backend errors
          formErrors[field] = backendErrors[field].map(_.capitalize).join('. ') + '.';
        } else {
          formErrors[field] = _.capitalize(backendErrors[field]);
        }
      }
    }
    return formErrors;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/forms/form-utils.ts